// mui
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const RootStyles = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: Number(theme.shape.borderRadius) * 2,
  backgroundColor: theme.palette.background.neutral,
}));


export default function OfferCrewContractNoResponse() {
  return (
    <RootStyles>
      <Typography variant="body2">
        크루가 계약 조건을 제안할 수 있는 기한이 지나 매칭이 종료되었습니다.
      </Typography>
    </RootStyles>
  )
}
